//
import Lenis from '../../../../_modules/lenis';
window.Lenis = Lenis;

//
import { Flowmap, Text, Geometry, Renderer, RenderTarget, Camera, Color, Transform, Vec2, Vec3, Program, Plane, Texture, TextureLoader, Mesh } from '../../../../_modules/ogl-master/src/index.js';
window.OGL = {
	Renderer : Renderer,
	RenderTarget : RenderTarget,
	Camera : Camera,
	Transform : Transform,
	Color : Color,
	Vec2 : Vec2,
	Vec3 : Vec3,
	Program : Program,
	Plane : Plane,
	Texture : Texture,
	TextureLoader : TextureLoader,
	Mesh : Mesh,
	Flowmap : Flowmap,
	Text : Text,
	Geometry : Geometry
}


// //
// import Hls from "hls.js";
// window.Hls = Hls;


//
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
gsap.registerPlugin( ScrollTrigger, ScrollToPlugin );
gsap.config({ nullTargetWarn: false });
window.gsap = gsap;


//
import barba from '@barba/core';
window.barba = barba;